import { GET_STORAGE_IMAGE_GET_URL, GET_STORAGE_IMAGE_PUT_URL } from '../ImageUpload/API';

const query = {
  getStorageImageUrl: GET_STORAGE_IMAGE_PUT_URL,
  getStorageUrl: GET_STORAGE_IMAGE_GET_URL,
};

export { query };
